import { CConfig } from "./CConfig";
import { CGame } from "./CGame";

export class CRandomUser {

	public static get openid():string {
		var ds:string = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		var id:string = "";
		for( let i = 0; i < 32; i ++ ) {
			id += ds.charAt(CGame.GetRand(0, ds.length));
		}
		//id = crypto.randomUUID();
        //return sprintf("U615949877d4b8513fb076535e78%05d", CGame.GetRand(0, 100000));
		return id;
    }

    public static get avatar():string {
        var avatarList:string[] = [
				"Html5/icons/angry_monkey_benji_park_01.png", 
				"Html5/icons/az-lizard_benji_park_01.png",
				"Html5/icons/bug_nicu_buculei_01.png",
				"Html5/icons/bunny_01.png",
				"Html5/icons/horse_1_rotkevich_konsat_01.png",
				"Html5/icons/scorpion-md-v0.1.png",
				"Html5/icons/png-0001.png",
				"Html5/icons/png-0002.png",
				"Html5/icons/png-0003.png",
				"Html5/icons/png-0004.png",
				"Html5/icons/png-0005.png",
				"Html5/icons/png-0006.png",
				"Html5/icons/png-0007.png",
				"Html5/icons/png-0008.png",
				"Html5/icons/png-0009.png",
				"Html5/icons/png-0010.png",
				"Html5/icons/png-0011.png",
				"Html5/icons/png-0012.png",
				"Html5/icons/png-0013.png",
				"Html5/icons/png-0014.png",
				"Html5/icons/png-0015.png",
				"Html5/icons/png-0016.png",
				"Html5/icons/png-0017.png",
				"Html5/icons/png-0018.png",
				"Html5/icons/png-0019.png",
				"Html5/icons/png-0020.png",
				"Html5/icons/seal.png"
				];
        return CConfig.baseURL+avatarList[CGame.GetRand(0, avatarList.length)];
    }

    public static get socialName():string {
        var names:string[] = ["蔡淑婷", "吳政龍", "陳彥純", "謝智傑", "宋立偉", "王乃聿", "謝孟欣", "吳俐鴻",
        "盛良祥", "陳建良", "蔡力利", "劉肇喬", "周青樺", "黃文意", "陳泰珠", "浦佩珊", "林詩玟", "王明杰", "丁昭禾",
        "周中財", "陳儒啟", "林佳儀", "李進佳", "謝文東", "謝柏梅", "吳柏瑄", "林俊宏", "柯麗萍", "陸佳玲", "林佳純",
        "李明盛", "王菁名", "黃岳全", "劉恭文", "王心茵", "郭家瑜", "張介珊", "楊佳琳", "黃文彥", "游婉裕", "陳禎佳",
        "翁佩玲", "吳怡桂", "賴子勇", "王國瑋", "許雅泉", "林冠甫", "李佳凡", "曾立偉", "林欣芸", "張維善", "李鈞隆",
        "陳雅劭", "李孟妹", "劉柔",   "劉麗君", "劉鳳佩", "陳又郁", "黃郁希", "謝凱淳", "鄧佳慧", "毛皓來", "高秋明",
        "陳以維", "賴怡修", "黃雅忠", "沈琇宇", "吳政憲", "吳怡伶", "王大誠", "許慧萍", "周智強", "張嘉慧", "郭冠霖",
        "陳之紋", "楊雅孝", "李美吟", "劉人豪", "劉宇毓", "馬丞秋", "邱俊均", "陳彥霖", "楊宇霞", "項昭云", "林勝傑",
        "許立偉", "經芃平", "周鎮宇", "林婉婷", "陳欣穎", "黃鈺玉", "胡玫紹", "王守恭", "金佩芳", "邱英傑", "盧綠水",
        "吳峻坤", "林育宏", "黃玟君", "袁俊傑", "蔡誠尹", "李泰蕙", "盧明珠", "鄭雅花", "王明珊", "黃孟哲", "黃欣怡" ];

        return names[CGame.GetRand(0, names.length)];
    }
}